<!-- top navigation -->
<div class="site-header">
    <div class="top-bar">
        <div class="large-container">
            <div class="top-bar-wrapper">
                <div class="top-info">
                    <ul>

                        <li><i class="bi bi-geo-alt-fill"></i>91 Western Road, Brighton, England</li>
                        <li><i class="bi bi-headphones"></i>+44 1632 960896</li>
                    </ul>
                </div>
                <div class="top-right">
                    <div class="top-mail">
                        <i class="bi bi-envelope"></i>
                        <a href="mailto:http://info@securityrelated.com">info@securityrelated.com</a>
                    </div>


                    <ul class="top-icons">
                       
                        <li><a href="#"><i class="bi bi-facebook"></i></a></li>
                        <li><a href="#"><i class="bi bi-twitter"></i></a></li>
                        <li><a href="#"><i class="bi bi-linkedin"></i></a></li>
                        <li><a href="#"><i class="bi bi-instagram"></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>


    <div class="menu-bar">

        <div class="large-container" #stickyMenu [class.sticky]="viewModel.sticky">

            <div class="menu-wrapper">

                <a class="logoWhite" href="index.html" *ngIf="viewModel.iconView==1">
                    <img src="assets/icons/Transparent-2.png" alt="">
                </a>

                <a class="logoBlack" href="index.html" *ngIf="viewModel.iconView==0">
                    <img src="assets/icons/Transparent.png" alt="">
                </a>

                <a class="logoBlackSmallScreen" href="index.html">
                    <img src="assets/icons/Transparent.png" alt="">
                </a>

                <div class="main-menu" #myDiv (click)="myDiv.classList.toggle('active')"
                [ngClass]="viewModel.status ? 'hide' : 'show'" >

                    <ul class="menu-ul">

                        <li class="active menu" >
                            <a href="#" routerLink="/home" routerLinkActive="activeMenu"
                                [routerLinkActiveOptions]={exact:true}> Home
                             </a>
                        </li>

                        <li>
                            <a href="#" routerLink="/about-us" routerLinkActive="activeMenu"> About </a>
                        </li>

                        <li class="active menu-item-has-children">

                            <a> More </a>

                            <ul *ngIf="!viewModel.showMenu" class="sub-menu" #subMenu [class.subMenu]="viewModel.subMenu">

                                <li>
                                    <a routerLink="/blog-details" routerLinkActive="activeSubMenu"> Blog Details </a>
                                </li>

                                <li>
                                    <a routerLink="/service" routerLinkActive="activeSubMenu" > Service </a>
                                </li>

                                <li>
                                    <a routerLink ="/service-details"  routerLinkActive="activeSubMenu" > Service Details </a>
                                </li>

                                <li>
                                    <a routerLink ="/portfolio"  routerLinkActive="activeSubMenu"> Portfolio </a>
                                </li>

                                <li>
                                    <a routerLink="/portfolio-details"   routerLinkActive="activeSubMenu"> Portfolio Details </a>
                                </li>

                            </ul>

                        </li>

                        <li class="menu-item-has-children">

                            <a> Contact </a>

                            <ul *ngIf="!viewModel.showMenu" class="sub-menu" #subMenu [class.subMenu]="viewModel.subMenu">

                                <li>
                                    <a href="#" routerLink="/contact-us" routerLinkActive="activeSubMenu"> Contact Us </a>
                                </li>
 
                                <li>
                                    <a href="#" routerLink="/contact-sales" routerLinkActive="activeSubMenu"> Contact Sales </a>
                                </li>

                            </ul>

                        </li>

                    </ul>
                    

                    <div class="menu-option">

                        <div class="user">

                            <div class="icon">
                                <i class="bi bi-person-fill"></i>
                            </div>

                            <ul #subMenu [class.subMenu]="viewModel.subMenu">

                                <li>
                                    <a  (click)="click_showLoginModal()"> Login </a>

                                </li>
                                <li>
                                    <a href="#" routerLink="sign-up" > Sign Up </a>

                                </li>
                              
                            </ul>

                        </div>

                        <!-- <div class="search"><i class="bi bi-search"></i></div> -->

                    </div>

                </div>

                <div class="menu-toggle" #myDiv (click)="myDiv.classList.toggle('active')" (click)="viewModel.showMenu=!viewModel.showMenu" 
                    aria-expanded="false">
                </div>
            </div>

        </div>

    </div>

</div>
